// 搜索参数拼接成sql
export function pushToWhere (where, val) {
  if (val.length > 0) {
    where.push(val);
  }
}

/**
 * 拼接成sql的形式
 * @param key 请求字段
 * @param factor 查询条件 like，=之类
 * @param val 值
 * @param nullValue  字段为空时的值 '' 0 null
 * @returns {[]}
 */
export function joinSql (key, factor, val, nullValue) {
  const nullValues = ['', 0, null];
  let result = [];
  
  if (nullValues.indexOf(nullValue) >= 0 && val !== nullValue) {
    result = [key, factor, val];
  }
  return result;
}
